<div *ngFor="let item of formArray.controls">
  <mat-form-field *ngFor="let field of fields">
    <input type="text"
      matInput
      [placeholder]="field?.placeholder"
      [formControl]="item.get(field.property)">
  </mat-form-field>
  <button (click)="openItem.emit(item)"
    mat-flat-button
    type="button">Open</button>
  <button (click)="removeItem.emit(item)"
    mat-flat-button
    color="warn"
    type="button">Remove</button>
</div>
<button type="button"
  mat-flat-button
  (click)="addItem.emit()">
  <ng-content></ng-content>
</button>